import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import './EvaluationOverview.css';
import { Typography } from '@mui/material';

class EvaluationOverview extends Component {
  static renderCurrentSectionScore = (totalCurrentPoints) => (
    <li>
      <Typography>
        <FormattedMessage id="enrollmentsmanager.sectionScore" />
        {` : ${totalCurrentPoints}`}
      </Typography>
    </li>
  );

  static renderAllScoreSection = (allPoints) => {
    let totalRawScore = 0;
    let totalScore = 0;
    let totalReviewScore = 0;
    for (let i = 0; i < allPoints.length; i += 1) {
      totalRawScore += allPoints[i].rawScore;
      totalScore += allPoints[i].total;
      totalReviewScore += allPoints[i].reviewScore || 0;
    }

    const totalAllPoints = totalRawScore + totalReviewScore;
    const percentage = Math.round((totalAllPoints / totalScore) * 100);

    let showPercentage = '';
    if (percentage <= 100) {
      showPercentage = `(${percentage}%)`;
    }
    return (
      <li>
        <Typography>
          <FormattedMessage id="enrollmentsmanager.totalScore" />
          {` : ${totalAllPoints} ${showPercentage}`}
        </Typography>
      </li>
    );
  };

  static calculateFinalizedScore = (points) => {
    const fullPoints = points.total;
    const rawPoints = points.rawScore;
    const reviewedPoints = points.reviewScore || 0;

    return {
      fullPoints,
      rawPoints,
      reviewedPoints,
      ...points,
    };
  };

  renderReviewSectionScore = (reviewedPoints) => {
    const { intl, isFaerbungReview } = this.props;
    return (
      <li>
        <Typography>
          {`
          ${intl.formatMessage({ id: 'enrollmentsmanager.pointsAchievedWithReview' })}
          ${isFaerbungReview ? intl.formatMessage({ id: 'enrollmentsmanager.faerbungAdditionalInfo' }) : ''} : ${reviewedPoints}
        `}
        </Typography>
      </li>
    );
  };

  renderIndividualScoreSection = (points, showSectionScore) => {
    const {
      fullPoints,
      rawPoints,
      reviewedPoints,
      rawScorePlusNormalReview,
    } = EvaluationOverview.calculateFinalizedScore(points);
    return (
      <div>
        <li>
          <Typography>
            <FormattedMessage id="enrollmentsmanager.pointsAchieved" />
            {` : ${rawPoints} / ${fullPoints}`}
          </Typography>
        </li>
        <li>
          <Typography>
            <FormattedMessage id="enrollmentsmanager.pointsAfterReview" />
            {` : ${rawScorePlusNormalReview} / ${fullPoints}`}
          </Typography>
        </li>
        {reviewedPoints ? this.renderReviewSectionScore(reviewedPoints) : ''}
        {showSectionScore ? EvaluationOverview.renderCurrentSectionScore(reviewedPoints + rawPoints) : ''}
      </div>
    );
  };

  render() {
    const {
      evaluationOverview,
      points,
      pointIndex,
      hideIndividualScores,
      userRole,
      evaluationType,
      auswertungSetting,
    } = this.props;

    const {
      passedSubmissions,
      submissionAmount,
      successPerSection,
      totalSubmissionPerSection,
    } = evaluationOverview;

    return (
      <div className="evaluationOverview">
        <ul>
          {
            evaluationType !== 'section' && (
              <>
                {
                  !auswertungSetting.hideParticipantCount && (
                    <li>
                      <Typography>
                        <FormattedMessage id="enrollmentsmanager.passedSubmissions" />
                        {` : ${passedSubmissions} / ${submissionAmount}`}
                      </Typography>
                    </li>
                  )
                }
                {
                  !auswertungSetting.hideSuccessRate && (
                    <li>
                      <Typography>
                        <FormattedMessage id="enrollmentsmanager.quotaPassedSubmissions" />
                        {` : ${Math.round((passedSubmissions * 100) / submissionAmount)}%`}
                      </Typography>
                    </li>
                  )
                }
              </>
            )
          }
          {
            userRole === 'admin'
            && !!successPerSection?.[pointIndex]
            && successPerSection.length > 1
            && !auswertungSetting.hideSectionSummary
            && (
              <li>
                <Typography>
                  <FormattedMessage id="enrollmentsmanager.passedSubmissionsSection" />
                  {` : ${successPerSection[pointIndex]} / ${totalSubmissionPerSection[pointIndex]}`}
                </Typography>
              </li>
            )
          }
          {
            !hideIndividualScores
            && (
              <div>
                {this.renderIndividualScoreSection(points[pointIndex], points.length > 1)}
                {
                  !auswertungSetting.hideOverallScore && (
                    EvaluationOverview.renderAllScoreSection(points)
                  )
                }
              </div>
            )
          }
        </ul>
      </div>
    );
  }
}

EvaluationOverview.defaultProps = {
  points: undefined,
  pointIndex: undefined,
  hideIndividualScores: false,
  isFaerbungReview: false,
  evaluationType: undefined,
  auswertungSetting: {},
};

EvaluationOverview.propTypes = {
  evaluationOverview: PropTypes.shape({
    passedSubmissions: PropTypes.number.isRequired,
    submissionAmount: PropTypes.number.isRequired,
    successPerSection: PropTypes.arrayOf(PropTypes.number),
    totalSubmissionPerSection: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
  evaluationType: PropTypes.string,
  points: PropTypes.object,
  pointIndex: PropTypes.number,
  hideIndividualScores: PropTypes.bool,
  isFaerbungReview: PropTypes.bool,
  intl: intlShape.isRequired,
  userRole: PropTypes.string.isRequired,
  auswertungSetting: PropTypes.object,
};

const mapStateToProps = (state) => ({
  userRole: state.users.token?.role,
});

export default injectIntl(connect(mapStateToProps)(EvaluationOverview));
